import React from "react";
import "./lizenzContentSection.scss";
import NewImage from "../../../../assets/images/new-image.png";
import { NavLink } from "react-router-dom";
export default function LizenzContentSection() {
  return (
    <div>
      <div className="Lizenz-content-section-alignment">
        <div className="light-box-background">
          <div className="box-width">
            <div className="text-style">
              <ul>
                <li
                  className="animate__slideInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Durch Großeinkauf günstigere Preise für unsere Partner und
                  Kostendeckung der Zentrale
                </li>
                <li
                  className="animate__slideInUp animate__animated wow"
                  data-wow-offset="100"
                >
                  Kostenersparnis für Sie bei:
                </li>
                <li className="">
                  Vermarktungskosten wie Internet-Portale (ImmoScout, Immonet,
                  Immowelt ...), Printmedien etc.
                </li>
                <li className="">
                  Bei Nutzung der kostenpflichtigen Portale über DEUTSCHER
                  IMMOBILIEN DIENST bekommen Sie einen kostenlosen Zugang zur
                  webbasierten Makler-Software
                </li>
                <li className="">Bürobedarf</li>
                <li className="">Telekommunikationsgesellschaften</li>
              </ul>
            </div>
          </div>
          <div className="new-image-style">
            <NavLink to="/kontakt">
              <img
                className="animate__backInUp animate__animated wow"
                data-wow-offset="100"
                src={NewImage}
                alt="NewImage"
              />
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}
